import { useState } from "react";
import { IoMdClose } from "react-icons/io";
import { IoDocumentOutline } from "react-icons/io5";
import { useNavigate } from "react-router";

export default function Volunteer() {
    const [showModal, setShowModal] = useState(false);
    const [currentPdf, setCurrentPdf] = useState<string | null>(null);

    const openModal = (pdfUrl: string) => {
        setCurrentPdf(pdfUrl);
        setShowModal(true);
      };
      
      const closeModal = () => {
        setShowModal(false);
        setCurrentPdf(null);
      };

    const navigate = useNavigate()
    const isMobile = window.innerWidth < 1024;
    return (
        <div
            style={{
                padding: "20px",
                backgroundColor: "#f8f9fa",
                borderRadius: "10px",
                maxWidth: "900px",
                margin: "50px auto",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
            }}
        >
            <h2
                style={{
                    textAlign: "center",
                    fontSize: "2rem",
                    fontWeight: "bold",
                    color: "#0d9f7d",
                    marginBottom: "20px",
                }}
            >
                Volunteering Experience
            </h2>
            <p
                style={{
                    fontSize: "1.2rem",
                    lineHeight: "1.6",
                    color: "#333",
                    textAlign: "justify",
                }}
            >
                In 2016-2017, I collaborated with three colleagues to support the
                Lebanese association <strong>"L'Ecoute"</strong>, which takes care of
                handicapped children in Lebanon. Our efforts included organizing
                cupcake sales and distributing flyers across Beirut to raise awareness
                and encourage donations. We also partnered with <strong>"Arc-en-Ciel"</strong>, 
                a Lebanese association supporting marginalized communities, to sell 
                customized bracelets.
            </p>
            <p
                style={{
                    fontSize: "1.2rem",
                    lineHeight: "1.6",
                    color: "#333",
                    textAlign: "justify",
                }}
            >
                Through these initiatives, we collected 300,000 Lebanese Lira
                 (around $300 at the time), enabling us to secure a leg prosthesis for one child. 
                This experience, conducted as part of a school project at my high school 
                Collège Louise Wegmann highlighted the importance of teamwork, 
                compassion, and community support. All related documents are written in French, 
                reflecting the nature of the project.
            </p>


            <div
                style={{
                    display: "flex",
                    gap: "20px",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    marginTop: "20px",
                }}
            >
                <img
                    src="/images/v1.png"
                    alt="Cupcake sale"
                    style={{
                        maxWidth: "100%",
                        width:"300px",
                        height: "400px",
                        borderRadius: "10px",
                        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                    }}
                />
                <img
                    src="/images/v3.png"
                    alt="Bracelet sale"
                    style={{
                        maxWidth: "100%",
                        width:"300px",
                        height: "400px",
                        borderRadius: "10px",
                        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                    }}
                />
            </div>


            <div
                style={{
                    textAlign: "center",
                    marginTop: "30px",
                }}
            >
                <button
                    onClick={()=>openModal("/papers/VolunteerReport.pdf")}
                    style={{
                        padding: "10px 20px",
                        backgroundColor: "#0d9f7d",
                        color: "white",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontSize: "1.1rem",
                        // display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "10px",
                    }}
                >
                    View Report <IoDocumentOutline className="fs-5" />
                </button>
            </div>

              {showModal && currentPdf && (
                <div className="modal show" style={{ display: 'block' }} onClick={closeModal}>
                  <div className="modal-dialog modal-lg" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-content">
                      <div className="modal-header">
                        <button className="btn-close" onClick={closeModal}>
                        <IoMdClose className='mb-3'/>
                        </button>
                      </div>
                      <div className="modal-body">
                      {isMobile ? (
                    <div>
                    <p>Viewing the PDF on mobile or tablet may be limited. Please open it in fullscreen:</p>
                    <a
                        href={currentPdf}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary"
                    >
                        Open PDF
                    </a>
                    </div>
                ) : (
                    <iframe
                    src={currentPdf}
                    width="100%"
                    height="500px"
                    title="Research Paper"
                    />
                )}
                      </div>
                    </div>
                  </div>
                </div>
              )}


            <div className="mt-3">
                <button
                    onClick={() => navigate("/Rayan/Home")} 
                    style={{
                        padding: "10px 20px",
                        backgroundColor: "#0d9f7d",
                        color: "white",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontSize: "1.1rem",
                        fontWeight: "bold",
                    }}
                >
                    Back to Home
                </button>
            </div>
        </div>
    );
}
